// CSV « à la française » : point-virgule, virgule décimale, guillemets quand
// il le faut. C'est ce qu'Excel en français ouvre d'un double-clic, et ce que
// les logiciels de gestion importent sans réglage.

export type CelluleCsv = string | number | null | undefined;

/** Repère de début de fichier qui dit à Excel « ceci est de l'UTF-8 » — sans lui, les accents s'abîment. */
export const BOM_UTF8 = '\ufeff';

/**
 * Un nombre entier reste entier (un nombre de pièces n'a pas de centimes) ;
 * un montant garde deux décimales, virgule française, sans séparateur de milliers.
 */
export function nombreCsv(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',');
}

/** Un champ, protégé par des guillemets s'il contient le séparateur, un guillemet ou un retour à la ligne. */
export function champCsv(v: CelluleCsv, sep = ';'): string {
  if (v === null || v === undefined) return '';
  if (typeof v === 'number') return Number.isFinite(v) ? nombreCsv(v) : '';
  const doitCiter = v.includes(sep) || v.includes('"') || v.includes('\n') || v.includes('\r');
  return doitCiter ? `"${v.replace(/"/g, '""')}"` : v;
}

/** Le fichier entier. Fin de ligne CRLF : c'est ce qu'Excel sous Windows attend. */
export function csvDepuisLignes(lignes: readonly (readonly CelluleCsv[])[], sep = ';', finDeLigne = '\r\n'): string {
  return lignes.map((l) => l.map((c) => champCsv(c, sep)).join(sep)).join(finDeLigne) + (lignes.length > 0 ? finDeLigne : '');
}
